export default __webpack_public_path__ + "static/media/ltr.9440914d.svg";